import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Quotes, Star } from "@phosphor-icons/react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function FeaturedTestimonial() {
  const [t, setT] = useState(null);

  useEffect(() => {
    api.get("/testimonials", { params: { limit: 1 } }).then((r) => setT(r.data?.[0] || null)).catch((e) => console.warn("Featured testimonial failed to load", e));
  }, []);

  if (!t) return null;

  return (
    <aside
      data-testid="featured-testimonial"
      className="mb-8 flex items-center gap-4 border border-border border-l-4 border-l-[#C84A31] bg-white rounded-sm px-5 py-4 animate-in fade-in slide-in-from-top-2 duration-500"
    >
      {t.photo_path ? (
        <img src={`${BACKEND}/api/files/${t.photo_path}`} alt={t.name} className="w-14 h-14 rounded-full object-cover shrink-0 border border-border" />
      ) : (
        <Quotes size={32} weight="duotone" className="text-[#C84A31] shrink-0" />
      )}
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-0.5 text-[#C84A31]" aria-label="5 stars">
          {Array.from({ length: 5 }).map((_, i) => <Star key={i} size={12} weight="fill" />)}
          <span className="ml-2 text-[10px] uppercase tracking-[0.25em] text-muted-foreground">Angler approved</span>
        </div>
        <p data-testid="featured-testimonial-text" className="mt-1 text-sm text-foreground/85 italic line-clamp-2">"{t.text}"</p>
        <div data-testid="featured-testimonial-name" className="mt-1 text-xs font-display">
          {t.name}{t.location && <span className="text-muted-foreground uppercase tracking-widest"> · {t.location}</span>}
        </div>
      </div>
    </aside>
  );
}
